const capabilities = [
  {
    title: 'AI & Machine Learning Models',
    description: 'Forecasting, anomaly detection, scoring systems, and domain-specific ML models deployed into production with full monitoring.',
    icon: '🧠',
    features: ['Forecasting systems', 'Anomaly detection', 'Scoring models', 'Production monitoring']
  },
  {
    title: 'Predictive Insights & Dashboards',
    description: 'Real-time analytics, trend detection, and explainable insights that help teams act faster and more accurately.',
    icon: '📊',
    features: ['Real-time analytics', 'Trend detection', 'Explainable insights', 'Decision support']
  },
  {
    title: 'Automation & Decision Systems',
    description: 'Event-driven AI workflows that reduce manual work and accelerate operational throughput.',
    icon: '⚙️',
    features: ['Workflow automation', 'Event-driven systems', 'Decision engines', 'Process optimization']
  },
  {
    title: 'Custom Integrations',
    description: 'APIs, system connectors, and data pipelines built around your existing software stack.',
    icon: '🔗',
    features: ['API development', 'System connectors', 'Data pipelines', 'Legacy integration']
  },
  {
    title: 'MLOps & Data Infrastructure',
    description: 'Model deployment, versioning, governance, drift monitoring, and operational stability for large-scale environments.',
    icon: '🏗️',
    features: ['Model deployment', 'Version control', 'Drift monitoring', 'Operational stability']
  }
];

const OurCapabilities = () => {
  return (
    <section data-testid="capabilities-section" className="py-24 px-6 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-wide">
            Our <span className="text-[#00E600]">Capabilities</span>
          </h2>
          <p className="text-[#B3B3B3] text-lg max-w-2xl mx-auto">
            Technical expertise that powers our solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              data-testid={`capability-card-${index}`}
              className="group relative bg-[#0D0D0D] border border-[#2F2F2F] rounded-lg p-6 md:p-8 hover:border-[#00E600] transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,230,0,0.2)]"
            >
              <div className="text-5xl mb-4 filter grayscale group-hover:grayscale-0 transition-all duration-300">
                {capability.icon}
              </div>

              <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide">
                {capability.title}
              </h3>

              <p className="text-[#B3B3B3] leading-relaxed mb-4">
                {capability.description}
              </p>

              <ul className="space-y-2">
                {capability.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start space-x-2 text-sm text-[#B3B3B3]">
                    <svg className="w-4 h-4 text-[#00E600] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#00E600] to-[#36E0A8] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurCapabilities;
